import React, { useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';
import Spinner from './Components/Spinner';

function SavedSearches() {
  const { user } = useAuth();
  const [searches, setSearches] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    console.log('a');
    if (!user?.id) return;
    console.log('s');
    fetch(`${process.env.REACT_APP_API_BASE}/savedsearches/${user.id}`)
      .then(res => res.json())
      .then(setSearches)
      .catch(() => setSearches([]));
  }, [user]);

  const deleteSearch = async (id) => {
    await fetch(`${process.env.REACT_APP_API_BASE}/savedsearches/${id}`, { method: 'DELETE' });
    setSearches(prev => prev.filter(s => s.id !== id));
  };

  const runSearch = (search) => {
    const query = new URLSearchParams();
console.log(search);
    if (search.zip) query.set('zip', search.zip);
    if (search.makeName) query.set('make', search.makeName);
    if (search.model) query.set('model', search.model);
    if (search.minYear) query.set('minYear', search.minYear);
    if (search.maxYear) query.set('maxYear', search.maxYear);
    if (search.minPrice) query.set('minPrice', search.minPrice);
    if (search.maxPrice) query.set('maxPrice', search.maxPrice);
    if (search.maxDistance) query.set('radius', search.maxDistance);
    if (search.sort) query.set('sort', search.sort);

    navigate(`/search?${query.toString()}`);
  };

  if (!searches) return <Spinner />;

  return (
    <div style={{ padding: '2rem' }}>
      <h2>Saved Searches</h2>
      {searches.length === 0 ? (
        <p>You haven’t saved any searches yet.</p>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {searches.map(search => (
            <li key={search.id} style={{
              display: 'flex', justifyContent: 'space-between',
              padding: '0.5rem 0', borderBottom: '1px solid #ccc'
            }}>
              <div onClick={() => runSearch(search)} style={{ cursor: 'pointer' }}>
                <div style={{ color: '#0077cc', textDecoration: 'underline' }}>
                  {search.name || 'Unnamed Search'}
                </div>
                <div style={{ fontSize: '0.9rem', color: '#555', marginTop: '0.3rem' }}>
                  {[
                    search.zip && `Zip: ${search.zip}`,
                    search.makeName && `Make: ${search.makeName}`,
                    search.model && `Model: ${search.model}`,
                    search.minYear && `Year ≥ ${search.minYear}`,
                    search.maxYear && `Year ≤ ${search.maxYear}`,
                    search.minPrice && `Price ≥ $${search.minPrice}`,
                    search.maxPrice && `Price ≤ $${search.maxPrice}`,
                    search.maxDistance && `Within ${search.maxDistance} mi`
                  ].filter(Boolean).join(' | ')}
                </div>
              </div>
              <button onClick={() => deleteSearch(search.id)} style={{
                background: 'none', border: 'none', color: 'red', cursor: 'pointer'
              }}>
                ✕
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default SavedSearches;
